<template>
  <div class="default-footer-info">
    <h4 class="default-footer-info--title" v-if="config.title">
      {{ config.title }}
    </h4>
    <v-lazy-img v-if="config.logo_url" :data-url="config.logo_url" style="margin-bottom: 8px" alt="" />
    <div class="default-footer-info--body">
      <p class="page_text_font default-footer-info--body__content" v-if="config.content">
        {{ config['content'] }}
      </p>
      <div class="text-left d-md-block d-inline-block">
        <p class="page_text_font" v-if="config.address">
          <span class="iconfont icon-dingweixiao"></span> {{ config['address'] }}
        </p>
        <p class="page_text_font" v-if="config.phone">
          <span class="iconfont icon-telephone"></span> {{ config['phone'] }}
        </p>
        <p class="page_text_font" v-if="config.email">
          <span class="iconfont icon-youxiang"></span> {{ config['email'] }}
        </p>
      </div>
    </div>
    <ul class="default-footer-info--social_medias" v-if="social_medias_on">
      <template v-for="(item, index) in this.config.social_medias">
        <li v-if="item && item.open_url" :key="'social_medias' + index">
          <a class="page_text_font" :href="item.open_url" target="_blank">
            <span :class="`iconfont icon-cm-${index === 'instagram' ? index + '-fill' : index}`"></span
          ></a>
        </li>
      </template>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    config: {},
  },
  computed: {
    social_medias_on() {
      let { social_medias } = this.config
      let onOff = false
      if (!social_medias || !Object.prototype.toString.call(social_medias) === '[object Object]') return onOff
      for (const key in social_medias) {
        if (Object.hasOwnProperty.call(social_medias, key) && social_medias[key] && social_medias[key]['open_url']) {
          onOff = true
        }
      }
      return onOff
    },
  },
}
</script>
<style scoped lang='scss'>
* {
  margin: 0;
  padding: 0;
}
img {
  max-width: 100%;
}
a {
  text-decoration: none;
}
li {
  list-style: none;
}
.default-footer-info {
  &--title {
    margin-bottom: 10px;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: var(--default-foot-tx-color, black);
    font-family: var(--title-font-family);
  }
  &--body {
    line-height: 24px;
    font-size: 16px;
    font-family: var(--text-font-family);
    color: var(--default-foot-tx-color, black);
    p {
      position: relative;
      margin-bottom: 10px;
      &:not(.default-footer-info--body__content) {
        padding-left: 30px;
      }
      word-break: break-all;
      .iconfont {
        position: absolute;
        top: 0;
        left: 0;
      }
      &:last-child {
        margin-bottom: 20px;
      }
    }
  }
  &--social_medias {
    li {
      display: inline-block;
      &:not(:last-child) {
        margin-right: 25px;
      }
    }
    .icon-cm-instagram-fill,
    .icon-cm-youtube {
      font-size: 18px;
    }
    .iconfont {
      color: var(--default-foot-tx-color, black);
    }
  }
}
</style>